import $ from 'jquery';

const $W = $(window);

$.onAuth(async auth => {
  $W.on('notify:theme', async (evt, data) => {
    let $theme = $('#theme');
    let $meta = $('meta[name=theme-color], meta[name=msapplication-navbutton-color], meta[name=apple-mobile-web-app-status-bar-style]');
    console.log('notify:theme', data);

    if (data && data.uri) {
      if (!$theme.length) $theme = $('<link id="theme" rel="stylesheet"/>').appendTo('head');
      $theme.attr('href', data.uri);

      if (!$meta.length) $meta = $('<meta name="theme-color"/><meta name="msapplication-navbutton-color"/><meta name="apple-mobile-web-app-status-bar-style"/>').appendTo('head');
      $meta.attr('content', data.primary);
    } else {
      $theme.remove();
      $meta.remove();
    }
  });
});
